import { render, staticRenderFns } from "./addCatalogue.vue?vue&type=template&id=f069211c&"
import script from "./addCatalogue.vue?vue&type=script&lang=js&"
export * from "./addCatalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports